export default "__VITE_ASSET__BFESjrux__"